import { Chip, Tooltip } from "@mui/material";

import { useAppContext } from "../../../../../../2_ksbHub/context/appContext";
import { SUBJECT_LABELS } from "../config/subjectConfig";

export default function BszSubjectChip({ subject, count, selected, onClick }) {
  const { isMobile } = useAppContext();

  const chip = (
    <Chip
      label={`${
        isMobile ? (SUBJECT_LABELS[subject] ?? subject) : subject
      } (${count})`}
      clickable
      size="small"
      color={selected ? "primary" : "default"}
      onClick={onClick}
    />
  );

  return isMobile ? <Tooltip title={subject}>{chip}</Tooltip> : chip;
}
